import { useState, useRef, useEffect } from "react";
import { Send } from "lucide-react";
import { cn } from "../../../utils/utils";
import AIAssistantHeader from "../AIAssistantHeader";

const AIAssistantPanel = ({ isOpen, onClose }) => {
  const [inputValue, setInputValue] = useState("");
  const [messages, setMessages] = useState([
    {
      id: "welcome",
      senderId: "ai-assistant",
      content: `Xin chào, hôm nay tôi có thể giúp gì cho bạn?`,
      timestamp: new Date().toISOString(),
      status: "read",
      type: "text",
    },
  ]);

  const inputRef = useRef(null);
  const messagesEndRef = useRef(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSendMessage = () => {
    if (!inputValue.trim()) return;

    // Add user message
    const userMessage = {
      id: `user-${Date.now()}`,
      senderId: 0,
      content: inputValue,
      timestamp: new Date().toISOString(),
      status: "sent",
      type: "text",
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputValue("");

    // Simulate AI response
    // setTimeout(() => {
    //   const aiResponse = {
    //     id: `ai-${Date.now()}`,
    //     senderId: "ai-assistant",
    //     content:
    //       "Tôi đang xử lý yêu cầu của bạn. Đây là một phản hồi giả định cho mục đích demo.",
    //     timestamp: new Date().toISOString(),
    //     status: "read",
    //     type: "text",
    //   };
    //   setMessages((prev) => [...prev, aiResponse]);
    // }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="h-full flex flex-col border-l border-border">
      <AIAssistantHeader onClose={onClose} />

      <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
        {messages.map((message) => (
          <div
            key={message.id}
            className={cn(
              "mb-4",
              message.senderId === 0 ? "flex justify-end" : ""
            )}
          >
            <div
              className={cn(
                "max-w-[85%] rounded-lg p-3",
                message.senderId === 0
                  ? "bg-blue-600 text-white"
                  : "bg-white border border-gray-200"
              )}
            >
              <p className="text-sm">{message.content}</p>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className="p-3 border-t border-gray-200">
        <div className="flex items-center gap-2 bg-gray-100 rounded-full px-4 py-2">
          <input
            ref={inputRef}
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Hỏi aka AI Pro"
            className="flex-1 bg-transparent border-none outline-none text-sm"
          />
          <button
            onClick={handleSendMessage}
            disabled={!inputValue.trim()}
            className={cn(
              "p-2 rounded-full",
              inputValue.trim()
                ? "bg-blue-600 text-white"
                : "bg-gray-300 text-gray-500"
            )}
          >
            <Send size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIAssistantPanel;
